import {
  findNavigationRouteInActions,
  findNextPageUriInActions,
  findSubmittalAction,
} from '@nextforce/api'
import { flatMap } from 'lodash'
import { NotificationsPage } from 'notifications/queries/shared/types'
import { NotificationsSummary } from 'notifications/types'
import uuid from 'react-native-uuid'
import * as Response from './response'

export function convertNotifications(
  response: Response.Notifications,
  idGenerator?: () => string
): NotificationsPage {
  const newId = idGenerator ?? uuid.v4

  const notifications = flatMap(response.notifications, notification => {
    const route = findNavigationRouteInActions(notification.actions_v3)

    if (!route) {
      return []
    }

    const markAsReadAction = findSubmittalAction(notification.actions_v3)

    return [
      {
        id: newId() as string,
        title: notification.title,
        message: notification.message,
        read: notification.status === 'READ',
        type: notification.type,
        createdAt: notification.created_at,
        route,
        actions: markAsReadAction
          ? {
              markAsRead: markAsReadAction,
            }
          : undefined,
      },
    ]
  })

  const markAllAsReadAction = findSubmittalAction(response.actions_v3)
  const nextPageUri = findNextPageUriInActions(response.actions_v3)

  return {
    notifications,
    nextPageUri,
    actions: markAllAsReadAction
      ? {
          markAllAsRead: markAllAsReadAction,
        }
      : undefined,
  }
}

export function convertSummary(
  response: Response.Summary
): NotificationsSummary {
  return {
    unreadCount: response.unread_count,
    notifications: response.notifications,
  }
}
